import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom';
import ContentController from '../../apis/controller/content.controller';
import { images } from '../../assets/images';
import Validation from '../../Components/helper/validation';

function Getin_touchmodal(props) {
  // const [show, setShow] = useState(true);
  const [successMessage, setSuccessMessage] = useState();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactUsList, setContactUsList] = useState();
  const [contactInfo, setContactInfo] = useState();
  let defaultValues = {
    firstName: null,
    lastName: null,
    phoneNumber: null,
    email: null,
    message: null,
  };
  const [values, setValues] = useState(defaultValues);

  const [isError, setError] = useState({
    firstName: {
      rules: ["required", "alphabetic"],
      isValid: true,
      message: "",
    },
    lastName: {
      rules: ["required", "alphabetic"],
      isValid: true,
      message: "",
    },
    phoneNumber: {
      rules: ["required"],
      isValid: true,
      message: "",
    },
    email: {
      rules: ["required", "email"],
      isValid: true,
      message: "",
    },
    message: {
      rules: ["required"],
      isValid: true,
      message: "",
    },
  });
  let validation = new Validation(isError);

  const handleStates = (field, value) => {
    /** Validate each field on change */
    let node = validation.validateField(field, value);
    setError({ ...isError, [field]: node });
    /** Validate each field on change */
    if (!value || !value.trim()) {
      setValues({ ...values, [field]: "" });
    } else {
      setValues({ ...values, [field]: value });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getContactUsList();
    setValues(defaultValues);
  }, []);


  const getContactUsList = async () => {
    setLoading(true);
    let res = await new ContentController().contactUs();
    if (res && res.status) {
      setContactUsList(res.page);
      setContactInfo(res.contactInfo)
    }
    setLoading(false);
  }

  const addContactUs = async () => {
    let validation = new Validation(isError);
    let isValid = await validation.isFormValid(values);
    if (isValid && !isValid.haveError) {
      let response = await new ContentController().contactUsForm(values);
      if (response && response.status) {
        setSuccess(response.status);
        setSuccessMessage(response.message);
      }
    } else {
      setError({ ...isValid.errors });
    }
  };

  const handleSubmit = event => {
    // 👇️ prevent page refresh
    event.preventDefault();

    console.log('form submitted ✅');
  };
  return (
    <>
      <Modal show={props.show} onHide={props.closemodel} size="lg" aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className='get_in_touch_wrap'>
            <div className='inner_area_get_in_touch'>
              <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                <div className='left_area' style={{ backgroundImage: `url(${images.get_in_touch})` }}>
                  <div className="section_title both_line text-center"><h2>Get  In Touch</h2></div>
                  <div className='form_area_in'>
                    <form >
                      <div className='qucik_form_regst'>
                        {success == false ?
                          <div className='row'>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
                              <div className="form_controlers" controlId="exampleForm.ControlInput1">
                                <input type="text" className='form-control' placeholder="First Name" onChange={(e) => {
                                  handleStates(
                                    "firstName",
                                    e.target.value
                                  );
                                }}
                                  value={
                                    values.firstName
                                      ? values.firstName
                                      : ``
                                  } />
                                <div className='icon'><i className="fas fa-user"></i></div>
                                {isError.firstName.message ? (
                                  <p className="valid-helper">
                                    {isError.firstName.message}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'>
                              <div className="form_controlers" controlId="exampleForm.ControlInput1">
                                <input type="text" className='form-control' placeholder="Last Name" onChange={(e) => {
                                  handleStates(
                                    "lastName",
                                    e.target.value
                                  );
                                }}
                                  value={
                                    values.lastName
                                      ? values.lastName
                                      : ``
                                  } />
                                <div className='icon'><i className="fas fa-user"></i></div>
                                {isError.lastName.message ? (
                                  <p className="valid-helper">
                                    {isError.lastName.message}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                              <div className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                <input type="email" className='form-control' placeholder="Email Address" onChange={(e) => {
                                  handleStates(
                                    "email",
                                    e.target.value
                                  );
                                }}
                                  value={
                                    values.email
                                      ? values.email
                                      : ``
                                  } />
                                <div className='icon'><i className="fas fa-envelope"></i></div>
                                {isError.email.message ? (
                                  <p className="valid-helper">
                                    {isError.email.message}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                              <div className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                <input type="number" className='form-control' placeholder="Phone" onChange={(e) => {
                                  handleStates(
                                    "phoneNumber",
                                    e.target.value
                                  );
                                }}
                                  value={
                                    values.phoneNumber
                                      ? values.phoneNumber
                                      : ``
                                  } />
                                <div className='icon'><i className="fas fa-phone"></i></div>
                                {isError.phoneNumber.message ? (
                                  <p className="valid-helper">
                                    {isError.phoneNumber.message}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                              <div className="form_controlers" controlId="exampleForm.ControlTextarea1">
                                <textarea as="textarea" className='form-control' placeholder="Your Message" rows={3} onChange={(e) => {
                                  handleStates(
                                    "message",
                                    e.target.value
                                  );
                                }}
                                  value={
                                    values.message
                                      ? values.message
                                      : ``
                                  } />
                                <div className='icon'><i className="fas fa-envelope-open"></i></div>
                                {isError.message.message ? (
                                  <p className="valid-helper">
                                    {isError.message.message}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                              <div className='send_msg secondary_btn nav-item mx-auto'>
                                <button type='button' className='btn btn-outline-primary mx-auto d-block' onClick={() => addContactUs()}>Send Message</button>
                              </div>
                            </div>
                            {contactUsList && <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                              <div className='map'>
                                <div dangerouslySetInnerHTML={{ __html: contactUsList.map_iframe }} />
                                {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15280114.312265644!2d73.72997399968845!3d20.77118574818321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1656653923474!5m2!1sen!2sin" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                              </div>
                            </div>}
                          </div>
                          :
                          <div className="check_in">
                            <i className="fas fa-check-circle"></i>
                            <p>{successMessage && successMessage}</p>
                          </div>
                        }
                      </div>
                    </form>
                  </div>
                </div>
                {contactInfo && <div className='right_area'>
                  <div className='contact'>
                    <div className='head'>
                      <h4>
                        Contact Us
                      </h4>
                    </div>
                    <div className='reches_set'>
                      <div className='left_areas'>
                        <i className="fas fa-phone"></i>
                      </div>
                      <div className='right_areas'>
                        <h6>
                          Phone Number
                        </h6>
                        <a href='telto:8054964656'>
                          {contactInfo.phone_number_1}
                        </a>
                        <a href='telto:8968628088'>
                          {contactInfo.phone_number_2}
                        </a>
                      </div>
                    </div>
                    <div className='reches_set'>
                      <div className='left_areas'>
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div className='right_areas'>
                        <h6>
                          Location
                        </h6>
                        <p>
                          {contactInfo.address}
                        </p>
                      </div>
                    </div>
                    <div className='reches_set'>
                      <div className='left_areas'>
                        <i className="far fa-envelope"></i>
                      </div>
                      <div className='right_areas'>
                        <h6>
                          Email Address
                        </h6>
                        <a href='mailto:info@techcruizer.com'>
                          {contactInfo.email}
                        </a>
                      </div>
                    </div>
                    <div className='social'>
                      <ul>
                        <li>
                          <Link to={{ pathname: contactInfo.facebook }}><i className="fab fa-facebook-f"></i></Link>
                        </li>
                        <li>
                          <Link to={{ pathname: contactInfo.twitter }}><i className="fab fa-twitter"></i></Link>
                        </li>
                        <li>
                          <Link to={{ pathname: contactInfo.telegram }}><i className="fab fa-telegram-plane"></i></Link>
                        </li>
                        <li>
                          <Link to={{ pathname: contactInfo.linkedin }}><i className="fab fa-linkedin-in"></i></Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Getin_touchmodal
